



















































































































































import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import HeadPic from './snapshotPic.vue'
import GoodsService from '../../goods-new/comps/GoodsService.vue'
import ActDetail from './snapshotAct.vue'
import RichText from '@ivy/fts/comps/RichText.vue'

@Component({
  components: {
    GoodsService,
    HeadPic,
    ActDetail,
    RichText,
  },
})
export default class OrderSnapshot extends Vue {
  show: boolean = false
  snapshotInfo: any
  navbarHeight: number = 0 // app 状态栏高度
  tipText: string = `当前页面内容为订单快照，包含订单创建时的商品
                     描述和下单信息，双方产生交易争议时，该页面可
                     作为判断依据。`
  get hasActive() {
    return (
      this.snapshotInfo.activity &&
      Object.keys(this.snapshotInfo.activity).length > 0
    )
  }

  get fromErp() {
    return !!this.$route.query.fromErp
  }

  get envType() {
    return env.type
  }

  beforeCreate() {
    document.title = '交易快照'
  }
  async created() {
    let id = this.$route.query.id
    let tid = this.$route.query.tid
    if (!tid) {
      return this.$Toast('订单不存在')
    }
    await env.init()
    this.navbarHeight = (await env.getNavbarHeight()) || 25
    if (!(await env.getIsLogin()) && !this.fromErp) {
      return await env.login()
    }
    // 获取快照信息
    let { data: snapshotInfo } = await this.$axios.get(
      '/api/goods/order/snapshot/snapshot',
      {
        params: {
          id,
          tid,
          sku_snapshot_id: this.$route.query.skuSnapshotId,
          sku_id: this.$route.query.skuId,
          check_login: 1 - +this.fromErp,
        },
      }
    )
    this.snapshotInfo = snapshotInfo
    this.show = true
  }
  viewGroupRule() {
    if (this.snapshotInfo.activity.rule_pic) {
      return this.$router.push(
        `/picPage?src=${this.snapshotInfo.activity.rule_pic}`
      )
    }
  }
  back() {
    window.history.go(-1)
  }
}
